var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_logout",
    transform: "translate(-4.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "holder",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.511209,10.9550285 L14.6668073,9.11062679 C14.2738556,8.71767515 14.2718055,8.08262478 14.6622282,7.69220209 C15.0526509,7.3017794 15.6877012,7.30382951 16.0806529,7.69678115 L19.6385097,11.254638 C20.0314614,11.6475896 20.0335115,12.28264 19.6430888,12.6730627 L16.1054112,16.2107402 C15.7149886,16.6011629 15.0799382,16.5991128 14.6869865,16.2061612 C14.2940349,15.8132095 14.2919848,15.1781592 14.6824075,14.7877365 L16.5091874,12.9609566 L9.0009353,12.9367178 C8.44700601,12.9349296 7.99650793,12.4844315 7.99471436,11.9305022 C7.99293146,11.3765729 8.44053023,10.9289742 8.99445954,10.9307624 L16.511209,10.9550285 Z M5.99825662,17.0005253 L11.0008717,17.0005253 C11.552675,17.0005253 12,17.4481242 12,18.0002654 C12,18.5524065 11.552675,19.0000027 11.0008717,19.0000027 L4.99912831,19.0000027 C4.44732498,19.0000027 4,18.5524065 4,18.0002654 L4,5.99974549 C4,5.44670392 4.44873024,4.998733 5.00143194,5.00000269 L10.9975462,5.01384152 C11.5493481,5.01511456 11.9956405,5.46374423 11.9943682,6.01588394 C11.993096,6.56802364 11.5447408,7.01458931 10.992939,7.01331627 L5.99825662,7.00179323 L5.99825662,17.0005253 Z",
    id: "path-1",
    fill: "#4C4C4C",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.2650b380275ad844554ff3687ba08cc3.svg";
export { ForwardRef as ReactComponent };